/**
 * mioSegno가 중앙 공통 프로필에서 직접 변경하는 값은 표시 이름뿐입니다.
 * 전화번호·생일·달력 구분은 중앙회원에 필드만 준비해 두되, mioSegno 화면과
 * 요청 본문에는 포함하지 않습니다.
 */
export interface DisplayNameUpdatePayload {
  displayName: string
}

export function displayNameUpdatePayload(displayName: string): DisplayNameUpdatePayload {
  return { displayName }
}
